(function() {
/*
    Imports value from a remote field when it updates, if this form is `$pristine`.
    If the remote field is a select field, only option `label` matches are accepted.

    Example HTML:
        <input type="text"
            ng-model="guest.FirstName"
            field-import="form.contactForm.firstName" />
*/
'use strict';

angular.module('TR')
    .directive('fieldImport', () => {
        // Deregister all instances
        let allowInit = true;
        let deregisterFns = [];
        const deregisterAll = () => {
            if (deregisterFns) {
                allowInit = false;
                deregisterFns.forEach(fn => fn());
                deregisterFns = null; // Clear memory
            }
        };

        return {
            restrict: 'A',
            require: '^form', // Parent ngForm
            scope: {
                ngModel: '=',
                fieldImport: '&'
            },
            link: (scope, el, attr, formCtrl) => {
                const remoteField = scope.fieldImport();

                // `remoteField` may be `false` if attribute contains a condition
                if (allowInit && typeof remoteField === 'object') {
                    init();
                }

                // Initialise
                function init() {
                    // If fields were autofilled, form is still `$pristine` so check value
                    if (scope.ngModel) {
                        deregisterAll();
                    } else {
                        // Set listeners
                        deregisterFns.push(
                            scope.$watch(
                                () => remoteField.$modelValue,
                                updateField
                            )
                        );
                        scope.$on('$destroy', deregisterAll);
                    }
                }

                // Populate this field
                function updateField(val) {
                    let submittedForm = false;
                    let lastParent = formCtrl;

                    while (!submittedForm && lastParent) {
                        submittedForm = lastParent.$submitted;
                        lastParent = lastParent.$$parentForm;
                    }

                    // If form was changed by user
                    if (!formCtrl.$pristine || submittedForm) {
                        deregisterAll();
                    } else {
                        // Set any falsy value to `undefined` to clear field
                        if (!val) {
                            val = undefined;
                        }
                        // For a select, only allow label matches (case insensitive)
                        if (val && el.is('select')) {
                            val = enforceMatch(
                                // i.e. ["--", "Mr", "Mrs", "Miss", "Ms", "Dr"]
                                $.map(el.find('option'), op => op.label),
                                val
                            );
                        }
                        // Set field value
                        scope.ngModel = val;
                        formCtrl.$setPristine(); // Only user edits will make '$pristine' false
                    }
                }

                // Restrict value to specified strings
                function enforceMatch(allowedVals, val) {
                    let i = allowedVals.length;
                    while (i--) {
                        const allowedStr = allowedVals[i];
                        if (val.toLowerCase() === allowedStr.toLowerCase()) {
                            return allowedStr;
                        }
                    }
                    // `val` not found, clear field
                    return undefined;
                }
            }
        };
    });
})();
